import React from 'react'

type Props = {
    fill?: string
}
function SvgClose({ fill = '#fff' }: Props) {
    return (
        <svg
            width={41}
            height={41}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#close_svg__filter0_d)">
                <path
                    d="M30 12.914L28.086 11 20.5 18.587 12.914 11 11 12.914l7.586 7.586L11 28.087 12.914 30l7.586-7.586L28.086 30 30 28.087 22.413 20.5 30 12.914z"
                    fill={fill}
                />
            </g>
            <defs>
                <filter
                    id="close_svg__filter0_d"
                    x={0}
                    y={0}
                    width={41}
                    height={41}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation={5.5} />
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0" />
                    <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
            </defs>
        </svg>
    );
}

export default SvgClose;